import React, { useState, useRef, useEffect } from "react";
import { ReactSVG } from "react-svg";
import { register } from "swiper/element/bundle";
import chevronLeft from "src/files/chevron-left.svg";
import chevronRight from "src/files/chevron-right.svg";

register();

/** Recommendation Page Card Swiper (Pseudo Tinder Swiper using SwiperJS Cards Effect) */
const RecSwiper = () => {
  const [cardIndex, setCardIndex] = useState(0);
  const [totalCards] = useState(window?.config?.quotes.length);
  const [quotes] = useState(window?.config?.quotes ?? []);
  const swiperRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    const swiperContainer = swiperRef.current;

    const params = {
      a11y: true,
      cardsEffect: {
        perSlideOffset: 1,
        perSlideRotate: 12,
        slideShadows: false,
      },
      navigation: {
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      },
    };

    Object.assign(swiperContainer, params);
    swiperContainer.initialize();

    /**
     * @property {number} realIndex - Index number of currently active slide considering rearranged slides in loop mode
     * https://swiperjs.com/swiper-api#methods--properties
     */
    function handleSlideChange() {
      setCardIndex(
        (swiperContainer.swiper.realIndex + 1).toString().padStart(2, "0")
      );
    }

    /**
     * @property {boolean} allowTouchMove - If false, then the only way to switch the slide is use of external API functions like slidePrev or slideNext
     *
     * @method unsetGrabCursor - Unset grab cursor
     * https://swiperjs.com/swiper-api#parameters
     */
    function handleIndexChange(swiper) {
      swiper.allowTouchMove = false;
      swiper.unsetGrabCursor();
    }

    function handleTouchEnd(swiper) {
      swiper.allowTouchMove = true;
    }

    setCardIndex(
      (swiperContainer.swiper.realIndex + 1).toString().padStart(2, "0")
    );

    /*setTotalCards(
      swiperContainer.swiper.slides.length.toString().padStart(2, "0")
    );
*/
    /**
     * @fires swiperContainer#swiper - Listen for Swiper events using addEventListener by 'on' (mount) and 'off' (unmount)
     * @event slideChange - Event will be fired when currently active slide is changed
     * @event realIndexChange - Event will fired on real index change
     * @event touchEnd - Event will be fired when user release Swiper.
     * https://swiperjs.com/swiper-api#events
     *
     * Use swiper in React with swiper-element
     * https://swiperjs.com/element
     */

    swiperContainer.swiper.on("slideChange", handleSlideChange);
    swiperContainer.swiper.on("realIndexChange", handleIndexChange);
    swiperContainer.swiper.on("touchEnd", handleTouchEnd);

    return () => {
      swiperContainer.swiper.off("slideChange", handleSlideChange);
      swiperContainer.swiper.off("realIndexChange", handleIndexChange);
      swiperContainer.swiper.off("touchEnd", handleTouchEnd);
    };
  }, []);

  return (
    <div className="recommendation-swiper">
      <div className="swiper-wrapper rec-swiper">
        <h3 className="rec-swiper__title">Did you know...</h3>
        <swiper-container
          ref={swiperRef}
          init="false"
          effect="cards"
          grabCursor="true"
          autoHeight="true"
          loop="true"
          slideActiveClass
          slideVisibleClass
          slideNextClass
          slidePrevClass
        >
          {quotes.length ? (
            <>
              {quotes.map((quote, index) => (
                <swiper-slide key={index}>
                  <div className="rec-swiper__card">{quote}</div>
                </swiper-slide>
              ))}
            </>
          ) : (
            <swiper-slide>
              <div className="rec-swiper__card">No information available.</div>
            </swiper-slide>
          )}
        </swiper-container>
        <div className="rec-swiper__controls">
          <button
            className="rec-swiper__button-prev"
            role="button"
            type="button"
            ref={prevRef}
          >
            <ReactSVG src={chevronLeft} wrapper={"svg"} />
          </button>
          <div className="rec-swiper__counter">
            <span className="rec-swiper__counter-current">{cardIndex}</span>/
            <span className="rec-swiper__counter-total">{totalCards}</span>
          </div>
          <button
            className="rec-swiper__button-next"
            role="button"
            type="button"
            ref={nextRef}
          >
            <ReactSVG src={chevronRight} wrapper={"svg"} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecSwiper;
